<template>
  <div>
    <vue-element-loading :active="isLoading" />
    <v-card class="pcard pcard--blue">
      <div class="pcard-header">
        <div class="pcard-header-left">
          <div class="pcard-icon-wrap" style="background:rgba(255,255,255,0.18)">
            <v-icon color="white" size="22">mdi-badge-account-outline</v-icon>
          </div>
          <div>
            <p class="pcard-header-sub" style="color:rgba(255,255,255,0.9)!important">{{ $t('sidebar.users') }}</p>
            <h2 class="pcard-header-title" style="color:#fff!important">{{ $t('sidebar.students') }}</h2>
          </div>
        </div>
      </div>
      <v-data-table
        item-key="id"
        :loading="isLoading"
        loading-text="Loading... Please wait"
        :headers="headers"
        :items="students"
        :search="search"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            :label="$t('pages.search')"
            class="mx-4"
          ></v-text-field>
        </template>
        <template v-slot:item.name="{ item }">
          <v-avatar rounded size="38">
            <v-img :src="getAvatarUrl(item)"></v-img>
          </v-avatar>
          {{ item.name }}
        </template>
        <template v-slot:item.created_at="{ item }">
          <small>{{ item.created_at | moment('DD/MM/YYYY') }}</small> -
          <small class="text-muted">
            {{ item.created_at | moment('HH:mm') }}
          </small>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                small
                class="mr-2"
                @click="viewUser(item.id)"
              >
                mdi-eye
              </v-icon>
            </template>
            <span>View</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading';
import { mesazhiIGabimit } from '@/utils/error-message';
import CreateButton from '@/components/CreateButton.vue';
import ActivationToolTip from '@/components/ActivationToolTip.vue';
import auth from '@/services/AuthService';
import { Keys } from '@/config';

export default {
  components: {
    ActivationToolTip,
    CreateButton,
    VueElementLoading,
  },
  data() {
    return {
      students: [],
      isLoading: false,
      search: '',
      avatarImageUrl: '',
      headers: [
        // { text: 'ID', value: 'id', align: 'start', filterable: false },
        { text: this.$t('table.name'), value: 'name' },
        { text: this.$t('table.school'), value: 'student_to_school.name' },
        { text: this.$t('table.created'), value: 'created_at' },
        { text: this.$t('table.actions'), value: 'actions', sortable: false },
      ],
    };
  },
  mounted() {
    this.loadStudents();
  },
  methods: {
    loadStudents() {
      this.isLoading = true;
      this.schools = [];
      axios
        .get(`/users/guardian-students`)
        .then((response) => {
          this.students = response.data?.students;
        })
        .catch((error) => {
          this.$notify({
            title: 'Error',
            text: mesazhiIGabimit(error),
            type: 'error',
          });
          auth.checkError(
            error.response.data.message,
            this.$router,
            this.$swal
          );
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    viewUser(id) {
      this.$router.push({ path: `/parent/students/view/student=${id}` });
    },
    getAvatarUrl(user) {
      if (user?.avatar) {
        return (this.avatarImageUrl = Keys.VUE_APP_API_URL + user?.avatar);
      } else {
        return (this.avatarImageUrl =
          Keys.VUE_APP_API_URL + '/storage/avatars/1/avatar.png');
      }
    },
  },
};
</script>

<style scoped>
.pcard { border-radius: 14px !important; overflow: hidden; border: none !important; }
.pcard-header {
  padding: 18px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pcard--blue .pcard-header { background: linear-gradient(135deg, #1565C0, #42A5F5); }
.pcard-header-left { display: flex; align-items: center; gap: 12px; }
.pcard-icon-wrap {
  width: 40px; height: 40px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
}
.pcard-header-sub {
  font-size: 11px; color: rgba(255,255,255,0.75);
  text-transform: uppercase; letter-spacing: 0.5px;
  margin: 0; font-weight: 600;
}
.pcard-header-title {
  font-size: 18px; font-weight: 800; color: #fff; margin: 0;
}
</style>
